import * as tabOverride from 'taboverride'

up.compiler('[note-form]', function(fragment, opts) {
  const $fragment = $(fragment)
  const siteNoteUrl = opts.siteNoteUrl
  const citeOtherNoteSearchPath = opts.citeOtherNoteSearchPath
  const previewPath = opts.previewPath
  const similarTitleSiteNotesPath = opts.similarTitleSiteNotesPath
  const newNote = opts.newNote
  const $proseField = $fragment.find('#note_prose')

  const prose = newProse($proseField)

  prose.maximize()
  prose.activateTabOverride()
  $(window).on('resize', prose.maximize)
  $(document).on('editor:resized', prose.maximize) // Other code can trigger this event to cause the editor to re-maximize

  const containerUpdate = function(html) { $fragment.find('.attachment-widget').html(html) }

  up.util.task(function() {
    /// /////////////////////////////////////////////////////////////////////////////
    // Focuses and select the title
    // (For some reason, autofocus: true inserts the cursor at the start of the title field.)
    $fragment.find('#note_title').select()
  })

  /// /////////////////////////////////////////////////////////////////////////////
  // Prose actions (formatting)
  $fragment.on('click', '[editor-action][data-role="bold"]', function(e) {
    e.preventDefault()
    prose.selectionFormatBold()
    setTimeout(() => $proseField.focus())
  })

  $fragment.on('click', '[editor-action][data-role="italic"]', function(e) {
    e.preventDefault()
    prose.selectionFormatItalic()
    setTimeout(() => $proseField.focus())
  })

  $fragment.on('click', '[editor-action][data-role="link"]', function(e) {
    e.preventDefault()
    prose.selectionLink()
    setTimeout(() => $proseField.focus())
  })

  $fragment.on('click', '[editor-action][data-role="format_codeblock"]', function(e) {
    e.preventDefault()
    prose.selectionCodeBlock()
    setTimeout(() => $proseField.focus())
  })

  /// /////////////////////////////////////////////////////////////////////////////
  // Preview

  $fragment.find('[editor-action][data-role="show_preview"]').on('up:click', showPreview)

  function showPreview(event) {
    event.preventDefault()
    const requestData = {}
    requestData.title = $fragment.find('input#note_title').val()
    requestData.prose = $fragment.find('textarea#note_prose').val()

    up.layer.open({ url: previewPath, method: 'POST', size: 'large', params: requestData })
  }

  /// /////////////////////////////////////////////////////////////////////////////
  // Attachment uploads
  function startUpload() {
    const $attachmentInput = $fragment.find('.attachment-widget--input')
    $attachmentInput.fileupload({
      dataType: 'json',
      url: siteNoteUrl,
    }).fileupload('send', {
      fileInput: $attachmentInput,
    }).complete(function(xhr) {
      if (xhr.status === 200) {
        containerUpdate(xhr.responseText)
      }
    })
    $attachmentInput.val('')
  }

  $fragment.on('change', '.attachment-widget--input', function(e) {
    $fragment.find('.attachment-widget--label-default').toggleClass('-hidden')
    $fragment.find('.attachment-widget--label-loading').toggleClass('-hidden')
    startUpload()

    e.preventDefault()
  })

  /// /////////////////////////////////////////////////////////////////////////////
  // Attachment controls
  $fragment.on('click', '.attachment-widget--insert-attachment', function(e) {
    // Inserts the link to an image attachment in the note prose
    const $this = $(this)

    prose.insertImage(
      'Image',
      $this.data('url'),
    )

    e.preventDefault()
  })

  $fragment.on('click', '.attachment-widget--delete-attachment', function(e) {
    // Removes an attachment
    if (confirm('Delete?')) {
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content
      $.ajax({
        url: $(this).data('url'),
        type: 'DELETE',
        headers: { 'X-CSRF-Token': csrfToken },
        success: containerUpdate,
      })
    }

    e.preventDefault()
  })

  /// /////////////////////////////////////////////////////////////////////////////
  // Cite other card
  function initCiteOtherCard() {
    // Cite other card
    const $input = $fragment.find('#query')
    const $citeControls = $fragment.find('.cite-other-note')

    const containerUpdate = function(html) {
      $citeControls.find('.cite-other-note--results').html(html)
      up.emit('editor:resized')
    }

    up.watch($input, { delay: 200 }, function() {
      const params = { query: $input.val() }
      $.get(citeOtherNoteSearchPath, params).done(containerUpdate)
    })

    function close() {
      $citeControls.toggleClass('-hidden')
      up.emit('editor:resized')
    }

    function reset() {
      $input.val('')
      $citeControls.find('.cite-other-note--results').empty()
    }

    $fragment.on('up:click', 'a[data-reference]', function(event) {
      up.event.halt(event)
      $fragment.find('#note_prose').replaceSelectedText(up.util.escapeHTML($(this).attr('data-reference'))).focus()
      reset()
      close()
    })

    $citeControls.on('click', '.cite-other-note--close', close)
  }

  initCiteOtherCard()

  $fragment.find('[editor-action][data-role="cite_card"]').on('up:click', toggleCiteOtherNote)

  function toggleCiteOtherNote(event) {
    $('.cite-other-note').toggleClass('-hidden')
    $('#query').focus()
    up.emit('editor:resized')

    return false
  }

  // /////////////////////////////////////////////////////////////////////////////
  // Search for similar cards based on title
  function initSimilarTitleSearch() {
    const $titleInput = $fragment.find('#note_title')
    const $similarNotes = $fragment.find('#similar_notes')

    const containerUpdate = function(html) { $similarNotes.html(html) }

    up.watch($titleInput, { delay: 300 }, function(value) {
      if (value !== '') {
        const params = { query: value }
        $.get(similarTitleSiteNotesPath, params).done(containerUpdate)
      }
    })

    function closeSuggestions(_event) {
      $similarNotes.html('')
      up.emit('editor:resized')
    }

    $similarNotes.on('click', '.similar-notes--close', closeSuggestions)
    up.on($titleInput[0].closest('form'), 'click', 'input, textarea, select', closeSuggestions)
  }

  if (newNote) {
    initSimilarTitleSearch()
  }

  return function() {
    $(window).off('resize', prose.maximize)
    $(document).off('editor:resized', prose.maximize)
  }

})

function newProse($textarea) {

  function maximize() {
    const $bottomActions = $textarea.closest('form').find('.note-actionbar')
    const spacing = 24
    const textareaTop = $textarea.offset().top
    let availableHeight = document.documentElement.clientHeight - textareaTop - ($bottomActions.outerHeight() || 0) - spacing
    availableHeight = Math.max(200, availableHeight)
    $textarea.outerHeight(availableHeight)
  }

  function activateTabOverride() {
    tabOverride.tabSize(2).autoIndent(true)

    const textarea = $textarea[0]
    tabOverride.set(textarea)

    // Enable "tabbing" out of the textarea with the escape button
    textarea.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        if (event.shiftKey) {
          document.querySelector('#note_title').focus()
        } else {
          // The next field would be #note_visibility. Experience showed that this is easily changed by accident. Thus we focus the second next field.
          document.querySelector('#note_links_to_content').focus()
        }
      }
    })
  }

  // /////////////////////////////////////////////////////////////////////////////
  // Selection / position helpers
  function tryPos() {
    return $textarea.selection('getPos')
  }

  function endPos() {
    const offset = $textarea.get(0).value.length
    return { start: offset, end: offset }
  }

  function pos() {
    return tryPos() || endPos()
  }

  function replaceSelection(text) {
    $textarea.selection('replace', { text })
    $textarea.change()
  }

  function insert(text) {
    $textarea.selection('setPos', pos())
    $textarea.selection('insert', { text, mode: 'before' })
    $textarea.change()
  }

  function getSelection() {
    return $textarea.selection('get')
  }

  // /////////////////////////////////////////////////////////////////////////////
  // Text / markup helpers
  function wrapText(text, formatting) {
    return formatting + text + formatting
  }

  function inlineLinkMarkup(text, url) {
    return '[' + text + '](' + url + ')'
  }

  function imageMarkup(text, url) {
    const prose = $textarea.get(0).value
    const cursorPosition = $textarea.get(0).selectionStart
    let markup = '!' + inlineLinkMarkup(text, url)
    if (prose.charAt(cursorPosition - 1) !== ' ' && prose.charAt(cursorPosition - 1) !== '\n' && cursorPosition !== 0) {
      markup = ' ' + markup
    }
    if (prose.charAt(cursorPosition) !== ' ' && prose.charAt(cursorPosition) !== '\n') {
      markup = markup + ' '
    }
    return markup
  }

  function codeBlockMarkup(text) {
    return '\n```\n' + text + '\n```\n'
  }

  function withSelection(cb, defaultText) {
    return function() {
      const text = getSelection()

      if (text.match(/^ *$/)) {
        // Sets a default text if none is given.
        cb(defaultText || 'Text')
      } else {
        cb(text)
      }
    }
  }

  // Public API
  return {
    insertImage: function(text, url) {
      insert(imageMarkup(text, url))
    },

    selectionFormatBold: withSelection(function(text) {
      replaceSelection(wrapText(text, '**'))
    }),

    selectionFormatItalic: withSelection(function(text) {
      replaceSelection(wrapText(text, '_'))
    }),

    selectionLink: withSelection(function(text) {
      const url = prompt('URL:')
      // Don't replace the selection if the "Cancel" button has been clicked
      if (url) {
        replaceSelection(inlineLinkMarkup(text, url))
      }
    }),

    selectionCodeBlock: withSelection(function(text) {
      replaceSelection(codeBlockMarkup(text))
    }, 'Code'),

    maximize,
    activateTabOverride,
  }
}
